<div class="container">
  <mat-toolbar class="custom-header">
    <span (click)="closeModal()">
      <mat-icon svgIcon="mat:arrow_back"></mat-icon>
    </span>
  </mat-toolbar>

  <h2>{{ "PROFILE.SUPPORT.TITLE" | translate }}</h2>

  <mat-form-field appearance="fill" style="width: 100%;">
    <mat-label>Scrivi qualcosa...</mat-label>
    <textarea matInput [(ngModel)]="message" rows="5" placeholder="Scrivi qualcosa...">
    </textarea>
  </mat-form-field>

  <div class="terms">
    <mat-checkbox class="custom-checkbox" [(ngModel)]="terms">
    </mat-checkbox>

    <ng-container *ngIf="translate.currentLang == 'it'">
      <span>
        Accetto i vostri
        <span class="link" (click)="guiService.goToExternalLink('https://itsdesifit.com/terms-of-use/')">
          Termini e condizioni d'uso
        </span>
        e
        <span class="link" (click)="guiService.goToExternalLink('https://itsdesifit.com/privacy-policy/')">
          l'Informativa sulla privacy
        </span>
      </span>
    </ng-container>

    <ng-container *ngIf="translate.currentLang == 'en'">
      <span>
        I accept your
        <span class="link" (click)="guiService.goToExternalLink('https://itsdesifit.com/terms-of-use/')">
          Terms of Service
        </span>
        and
        <span class="link" (click)="guiService.goToExternalLink('https://itsdesifit.com/privacy-policy/')">
          Privacy Policy
        </span>
      </span>
    </ng-container>
  </div>

  <div class="divider"></div>

  <div class="contact-us">
    <p>{{ "PROFILE.SUPPORT.CONTACT-US" | translate }}</p>
    <a href="mailto:info@itsdesifit.com">info&#64;itsdesifit.com</a>
  </div>

  <div class="footer-position">
    <button class="its-button" (click)="send()" [disabled]="!terms || message ===''&& terms">
      <span *ngIf="!spinner">{{"GENERIC.SEND" | translate}}</span>
      <mat-spinner *ngIf="spinner" diameter="20"></mat-spinner>
    </button>
  </div>
</div>
